import * as React from "react";

import { PresentationFacet } from "../model";

import {
  usePlpPresenterForTheFilterMenu_Mobile,
  useProductListLoadingState,
} from "../providers";

import { replaceAll } from "../utils";

interface HeaderProps {
  whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile?: PresentationFacet;
  onCloseModal: () => void;
}

export const Header: React.FunctionComponent<HeaderProps> = (props) => {
  const {
    whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile,
    onCloseModal,
  } = props;

  const { isLoading: isTheProductListLoading } = useProductListLoadingState();

  const { handleNavigatingBackFromAFilterSubmenu_onMobile } =
    usePlpPresenterForTheFilterMenu_Mobile();

  const modalHeading = whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile
    ? replaceAll(
        whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile.title,
        "_",
        " "
      )
    : "Filter";

  return (
    <div className="header">
      {whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile ? (
        <div
          className="button back"
          onClick={handleNavigatingBackFromAFilterSubmenu_onMobile}
        />
      ) : null}
      <p className="pretend">{modalHeading}</p>
      {!isTheProductListLoading && (
        <div className="button close" onClick={onCloseModal} />
      )}
    </div>
  );
};
